const OPENED_CLASS = 'is-opened';
const OPENED_MODAL_BODY_CLASS = 'opened-modal';

export default function ClickToggle() {
	const { body } = document;

	document.querySelectorAll('[data-target-toggle]').forEach((element: HTMLElement) => {
		const target = document.querySelector(element.dataset.targetToggle);
		if (!target) return;

		element.addEventListener('click', () => {
			target.classList.toggle(OPENED_CLASS);

			if (element.dataset.bodyToggle !== "0") {
				body.classList.toggle(OPENED_MODAL_BODY_CLASS);
			}
		});
	});
}